import { type IEarlyAccess } from '@/app/shared/types/earlyAccess';

import { useReduxSelector } from '../../../hooks';
import { rootStateBranchSelector } from '../../../utils/rootStateBranchSelector';

export const earlyAccessSelector = rootStateBranchSelector('earlyAccess');

export function useEarlyAccessSelector(): IEarlyAccess | null {
  return useReduxSelector(earlyAccessSelector);
}
